import React from 'react';
import FormSection from '../../../../../common/hookFormComponents/FormSection';
import { membershipCategoriesList } from '../../../../../../constants/membershipConstants';

const BasicInfo = (props) => {
  const fields = [
    {
      fieldType: 'select',
      colSpan: 1,
      label: 'Mill Type',
      name: 'categoryId',
      isRequired: true,
      choices: props.categoryOptions,
    },
    {
      colSpan: 1,
      name: 'millName',
      type: 'text',
      isRequired: true,
      label: 'Mill Name',
    },
    {
      fieldType: 'date',
      colSpan: 1,
      name: 'membershipDate',
      label: 'Membership Date',
      isRequired: true,
    },
    {
      fieldType: 'select',
      colSpan: 1,
      label: 'Membership Category',
      name: 'membershipCategory',
      isRequired: true,
      choices: membershipCategoriesList,
    },
    {
      fieldType: 'date',
      colSpan: 1,
      name: 'boardApprovalDate',
      label: 'Board Approval Date',
      isRequired: true,
    },
  ];

  return (
    <FormSection sectionName="Basic Information" sectionColumn={2} formFields={fields} {...props} />
  );
};

export default BasicInfo;
